import { loadable } from '../../../utils';

export const Refund = loadable(() => import('./Refund'), {});
export const Basic = loadable(() => import('./Basic'), {});
export const UpdateStatusSetPaid = loadable(() => import('./UpdateStatusSetPaid'), {});
